import { useState } from "react";
import styled from "styled-components";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

const ItemPhoto = styled("img")<{ loadingState: boolean; padRight: number }>`
  min-width: 72px;
  height: 72px;
  ${({ loadingState }) => (loadingState ? "display: none;" : "")}
  ${({ padRight }) => (padRight ? `padding-right: ${padRight}px;` : "")}
`;

export function SmartImage({ image = "", hideSkeleton = false, padRight = 0 }) {
  const [imageError, setImageError] = useState(false);
  const [loading, setLoading] = useState(false); // TODO: Somehow the onLoad below stopped having the normal effect?

  if ((imageError || loading) && !hideSkeleton) {
    return (
      <FixaSkeleton
        height="72px"
        width="72px"
        data-testid="halfSheetPhotoSkeleton"
      />
    );
  }

  if (!imageError && image)
    return (
      <ItemPhoto
        padRight={padRight}
        data-testid="halfSheetPhoto"
        onError={() => setImageError(true)}
        onLoad={() => setLoading(false)}
        src={image}
        loadingState={loading}
      />
    );

  return null;
}
